export default __webpack_public_path__ + "static/media/36I-117126_-37336_0.cd0ec902.jpg";